/**
 * AccountSlice State Definition
 * 
 * Defines the state interface and initial state for the account slice.
 */

import { AccountView } from '../types/accountTypes';

/**
 * State interface for the account slice.
 * Follows the standard pattern with account-specific naming.
 */
export interface AccountSliceState {
  /** The current account being viewed/edited, or null if none selected */
  currentAccount: AccountView | null;
  /** Backup of the account for discard functionality */
  accountBackup: AccountView | null;
  /** Whether any edits have been made since loading/saving */
  isEdited: boolean;
  /** List of field names that have been modified */
  editedFields: string[];
  /** Validation errors keyed by field name */
  validationErrors: Record<string, string>;
  /** Loading state for async operations */
  isLoading: boolean;
}

/**
 * Initial state for the account slice.
 */
export const initialState: AccountSliceState = {
  currentAccount: null,
  accountBackup: null,
  isEdited: false,
  editedFields: [],
  validationErrors: {},
  isLoading: false,
};
